"use client";

import classNames from "classnames";
import React, { ReactNode, Ref, useRef } from "react";
import mergeRefs from "react-merge-refs";

import useRipple from "../useRipple/useRipple";

import styles from "./Button.module.css";

const Button: React.FC<ButtonProps> = ({
  children,
  className,
  secondary,
  buttonRef,
  size = "regular",
  icon,
  ...rest
}) => {
  const rippleRef = useRef<HTMLElement>(null);

  useRipple(rippleRef);

  const buttonProps = {
    className: classNames(styles.button, className, {
      [styles.secondary]: secondary,
      [styles.small]: size === "small",
    }),
    ref: mergeRefs([rippleRef, ...(buttonRef ? [buttonRef] : [])]),
    children: (
      <>
        {icon}
        {children}
      </>
    ),
  };

  if (!rest.href) {
    return (
      <button
        {...buttonProps}
        {...(rest as React.ButtonHTMLAttributes<HTMLButtonElement>)}
      />
    );
  }

  return <a {...buttonProps} {...rest} />;
};

export type ButtonProps = {
  children?: ReactNode;
  className?: string;
  secondary?: boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  buttonRef?: Ref<any>;
  size?: "regular" | "small";
  icon?: ReactNode;
} & (
  | (React.AnchorHTMLAttributes<HTMLAnchorElement> & { href: string })
  | (React.ButtonHTMLAttributes<HTMLButtonElement> & { href?: undefined })
);

export default Button;
